<template>
  <div>
    <CRow>
      <CCol
        md="12"
        lg="12"
        sm="12"
        xs="12"
        class="float-right"
        @click="mtdBack"
      >
        <button
          @click="mtdBack"
          type="button"
          class="btn btn-sm text-white float-right"
          style="background: #e46666"
        >
          <i class="fas fa-hand-point-left"></i> Ir a Inicio
        </button>
      </CCol>
    </CRow>
    <div class="row" id="div_conte2">
      <div id="div_conte" class="col-md-10 mx-auto">
        <div class="bg-secondary text-white bg-opacity-10">
          <div class="text-center py-4 px-5" id="scroll-div">
            <div class="row">
              <button v-if="$store.getters.get_rol.id !== 7"
                class="div-button col m-2 p-2 text-white"
                @click="changePage('purchase_reports')"
              >
                REPORTES DE COMPRA
              </button>
              <button
                class="div-button col m-2 p-2 text-white"
                @click="changePage('sale_reports')"
              >
                REPORTES DE VENTA
              </button>
              <button  v-if="$store.getters.get_rol.id !== 7"
                class="div-button col m-2 p-2 text-white"
                @click="changePage('purchase_reports_general')"
              >
                REPORTES GENERAL COMPRA
              </button>
              <button  v-if="$store.getters.get_rol.id !== 7"
                class="div-button col m-2 p-2 text-white"
                @click="changePage('sale_reports_general')"
              >
                REPORTES GENERAL VENTA
              </button>
            </div>
            <div class="row">
              <button  v-if="$store.getters.get_rol.id !== 7 && $store.getters.get_rol.id !== 8 && $store.getters.get_rol.id !== 9"
                class="div-button col m-2 p-2 text-white"
                @click="changePage('utilidades_reports')"
              >
                REPORTES DE GANANCIAS
              </button>
              <button v-if="$store.getters.get_rol.id !== 9"
                class="div-button col m-2 p-2 text-white"
                @click="changePage('quotes_report')"
              >
                REPORTES DE COTIZACIONES
              </button>
            </div>
            <div class="row"  v-if="$store.getters.get_rol.id !== 9">
              <button
                class="div-button col m-2 p-2 text-white"
                @click="changePage('bead_report')"
              >
                REPORTES DE APERTURAS DE CAJA
              </button>
              <button
                class="div-button col m-2 p-2 text-white"
                @click="changePage('report_note')"
              >
                REPORTES DE NOTAS DE SALIDA
              </button>
            </div>
            <div class="row">
              <button
                class="div-button col m-2 p-2 text-white"
                @click="changePage('report_movement_stock')"
              >
                REPORTE DE MOVIMIENTOS DE STOCK
              </button>
            </div>
            <div class="row" v-if="$store.getters.get_rol.id !== 7 && $store.getters.get_rol.id !== 9 && $store.getters.get_company.id == 3">
              <button
                class="div-button col m-2 p-2 text-white"
                @click="changePage('report_warranty')"
              >
                REPORTES DE GARANTÍAS
              </button>
            </div>
            <div class="row" v-if="$store.getters.get_rol.id == 9">
              <button
                class="div-button col m-2 p-2 text-white"
                @click="changePage('billing_report')"
              >
                FACTURACIÓN ELECTRÓNICA
              </button>
              <button
                class="div-button col m-2 p-2 text-white"
                @click="changePage('note_credit_report')"
              >
                NOTAS DE CRÉDITO
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "home",
  created() {
    this.showBead();
  },
  data() {
    return {
      verificBead: false,
    };
  },
  methods: {
    ...mapActions(["get", "post"]),
    changePage: function (page) {
      if (page == "sale" && !this.verificBead) {
        Swal.fire({
          title: "No hay caja aperturada",
          icon: "warning",
        });
      } else {
        this.$emit("changePage", page);
      }
    },
    hasRoles(roles) {
      return roles.some((role) => this.userRoles.includes(role));
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showBead/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.verificBead = response.data ? true : false;
          }
        })
        .catch((errors) => {});
    },
    mtdBack() {
      this.$emit("setView", "home");
    },
  },
};
</script>

<style scoped>
#div_conte {
  border: 1.5px solid #926cdc;
  padding: 0;
  margin: 40px 0;
}

.div-button {
  background: #926cdc;
  border-radius: 15px;
  border: none;
}

#scroll-div {
  height: auto;
  overflow-y: scroll;
}

#scroll-div > div > button {
  height: 65px;
}

@media (max-width: 1320px) {
  #div_conte {
    border: 1.5px solid #926cdc;
    padding: 0;
    margin: 60px 0;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  #div_conte {
    border: 1.5px solid #926cdc;
    padding: 0;
    margin: 100px 0;
  }

  #scroll-div {
    height: 518px;
  }
}

@media (max-width: 768px) {
  #scroll-div > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #div_conte2 {
    padding-left: 30px;
    padding-right: 30px;
  }

  #scroll-div > div > button {
    height: 44px;
    width: 100%;
    margin: 5px 0;
  }

  .container {
    font-size: 11px;
  }

  #scroll-div {
    height: 450px;
  }
}

@media (max-width: 415px) {
  #scroll-div > div > button {
    height: 40px;
    font-size: 12px;
  }
}
</style>
